/**
 * ARK cart drawer — upsell carousel scroll + AJAX add-to-cart using same section rendering as Sense cart-drawer.
 */
(function () {
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a.ark-cart-drawer__continue-shop');
      if (!link) return;
      const drawer = link.closest('cart-drawer');
      if (drawer && typeof drawer.close === 'function') drawer.close();
    },
    true
  );

  const SCROLL_GROUP = '[data-ark-cart-upsell-group]';
  const TRACK = '[data-ark-cart-upsell-track]';

  document.addEventListener('click', (event) => {
    const prevBtn = event.target.closest('[data-ark-cart-upsell-prev]');
    const nextBtn = event.target.closest('[data-ark-cart-upsell-next]');
    const groupEl = event.target.closest(SCROLL_GROUP);
    if ((!prevBtn && !nextBtn) || !groupEl) return;

    const track = groupEl.querySelector(TRACK);
    if (!track) return;

    const card = track.querySelector('[data-ark-cart-upsell-card]');
    const gap = parseFloat(window.getComputedStyle(track).gap) || 12;
    const scrollStep = Math.max(track.clientWidth * 0.92, card ? card.offsetWidth + gap : 260);

    event.preventDefault();
    track.scrollBy({ left: nextBtn ? scrollStep : -scrollStep, behavior: 'smooth' });
  });

  document.addEventListener('change', (event) => {
    const sel = event.target.closest('[data-ark-cart-drawer-variant-select]');
    if (!sel) return;

    const opt = sel.options[sel.selectedIndex];
    if (!opt) return;

    const priceEl = sel.closest('[data-ark-cart-upsell-card]')?.querySelector('[data-ark-cart-drawer-variant-price]');
    if (!priceEl) return;

    const money = opt.getAttribute('data-price-money') || '';
    priceEl.textContent = money || '';
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form.ark-cart-drawer-upsell__product-form');
    if (!form) return;

    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    event.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    submitBtn?.setAttribute('aria-disabled', 'true');
    submitBtn?.classList.add('loading');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(form);
    formData.append('sections', drawer.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(typeof getCartAddJsUrl === 'function' ? getCartAddJsUrl() : `${window.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'ark-cart-drawer-upsell',
            errors: response.errors || response.description,
            message: response.message,
          });
          return;
        }

        if (typeof response.item_count === 'number' && response.item_count > 0) {
          drawer.classList.remove('is-empty');
          drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
        }

        return publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'ark-cart-drawer-upsell',
          productVariantId: formData.get('id'),
          cartData: response,
        }).then(() => {
          drawer.renderContents(response);
        });
      })
      .catch((err) => console.error(err))
      .finally(() => {
        submitBtn?.classList?.remove('loading');
        submitBtn?.removeAttribute('aria-disabled');
      });
  });
})();
